import { gql } from '@apollo/client';
const CHANNEL = gql `
  fragment ChannelFragment on ChannelNode {
    id
    name
    description
    iconUrl
    conversation {
      id
      title
      pageUrl
    }
  }
`;
export default CHANNEL;
